import { useAlertStore } from "../store/alertStore";

export default function AlertService(){

    const alertStore = useAlertStore();
    function Error(message: string, title: string = '錯誤 ! ') {
        // alertStore.message = message;
        // alertStore.title = title;
        // alertStore.type = 'error';
        // alertStore.setShow(true);
        alertStore.setMessage(true, message, 'error', title);
    }

    function Success(message: string, title: string = '成功 ! ') {
        // alertStore.message = message;
        // alertStore.title = title;
        // alertStore.type = 'success';
        // alertStore.setShow(true);
        alertStore.setMessage(true, message, 'success', title);
    }

    function Warning(message: string, title: string = '警告 ! ') {
        // alertStore.message = message;
        // alertStore.title = title;
        // alertStore.type = 'warning';
        // alertStore.setShow(true);
        alertStore.setMessage(true, message, 'warning', title);
    }

    function Info(message: string, title: string = '資訊 ! ') {
        // alertStore.message = message;
        // alertStore.title = title;
        // alertStore.type = 'info';
        // alertStore.setShow(true);
        alertStore.setMessage(true, message, 'info', title);
    }

    return {
        Error,
        Success,
        Warning,
        Info
    };
} 